import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyDx111Ywo91kw1ty7Mi2ayLsGSCOGjH8n0",
  authDomain: "swaroop-6b5ea.firebaseapp.com",
  projectId: "swaroop-6b5ea",
  storageBucket: "swaroop-6b5ea.appspot.com",
  messagingSenderId: "361922468179",
  appId: "1:361922468179:web:26a0bb999723010182a9a6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
